import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    FaComment,
    FaUser,
    FaAddressBook,
    FaUsers,
    FaChartBar,
    FaGlobe,
    FaCog,
    FaMoon,
    FaHistory,
    FaBell,
    FaSignOutAlt,
    FaDashcube
} from 'react-icons/fa';

const GlobalMiniSidebar = ({ setIsAuthenticated, onToggleDarkMode, isDarkMode }) => {
    // Get current location to determine active link
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    // Logout handler
    const handleLogout = async () => {
        try {
            // Get the auth token
            const token = localStorage.getItem('token');
            
            if (token) {
                // Notify the socket about logout
                try {
                    const socket = window.socket; // Assuming socket is initialized globally
                    if (socket && socket.connected) {
                        socket.emit('user-logout');
                    }
                } catch (socketError) {
                    console.error('Socket logout error:', socketError);
                }
                
                // Call logout API if it exists
                try {
                    await axios.post(
                        'http://localhost:5500/api/logout',
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                } catch (apiError) {
                    console.error('Logout API error:', apiError);
                    // Continue with local logout even if API call fails
                }
            }
            
            // Clear all localStorage items
            localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('username');
            localStorage.removeItem('email');
            localStorage.removeItem('firstname');
            localStorage.removeItem('lastname');
            localStorage.removeItem('role');
            localStorage.removeItem('rememberMe');
            // Don't remove FCM token as it might be needed for future notifications
            
            // Update authentication state
            if (setIsAuthenticated) {
                setIsAuthenticated(false);
            }
            
            // Navigate to login page
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    // Define all sidebar navigation items
    const navItems = [
        {
            icon: <FaChartBar />,
            path: '/summary',
            active: currentPath === '/summary'
        },
        {
            icon: <FaComment />,
            path: '/chat',
            active: currentPath === '/chat'
        },
        // {
        //     icon: <FaHistory />,
        //     path: '/chat-history',
        //     active: currentPath === '/chat-history'
        // },
        // {
        //     icon: <FaDashcube />,
        //     path: '/chat-summary',
        //     active: currentPath === '/chat-summary'
        // },
        // {
        //     icon: <FaBell />,
        //     path: '/notifications',
        //     active: currentPath === '/notifications' || currentPath === '/notifications-all'
        // },
        // {
        //     icon: <FaUsers />,
        //     path: '/users',
        //     active: currentPath === '/users'
        // },
        // {
        //     icon: <FaCog />,
        //     path: '/settings',
        //     active: currentPath === '/settings'
        // }
    ];

    return (
        <div className="mini-sidebar">
            <div className="mini-sidebar-content">
                <div className="app-logo">
                    <div className="logo-icon">AI-A</div>
                </div>
                <div className="nav-links">
                    {navItems.map((item, index) => (
                        <Link to={item.path} key={index} className={`nav-item ${item.active ? 'active' : ''}`}>
                            {item.icon}
                        </Link>
                    ))}
                </div>
                <div className="nav-bottom">
                    <div className="nav-item logout-button" onClick={handleLogout}>
                        <FaSignOutAlt />
                    </div>
                </div>
            </div>
        </div>
    );
};

GlobalMiniSidebar.defaultProps = {
    setIsAuthenticated: () => {},
    onToggleDarkMode: () => {},
    isDarkMode: false
};

export default GlobalMiniSidebar;